// A merchant following a super-admin link to one of these would otherwise land on a tab strip
// with nothing selected and an empty panel.
export const SUPER_ADMIN_TABS = ['learning', 'connectors'];

// Must list every Tabs.Panel value on ChatBotPage: a tab missing here resolves back to
// personalization, so clicking it would look like it did nothing.
export const TABS = ['personalization', 'conversations', 'knowledgeBase', 'customize', ...SUPER_ADMIN_TABS];

// The rail of the super admin block, in order. `needsAgentUi` sections stay hidden until the API
// returns the agentUi key on the chat bot.
export const SECTIONS = [
  { id: 'modelRuntime', label: 'Model & runtime' },
  { id: 'catalogSearch', label: 'Catalog & search' },
  { id: 'behaviourContext', label: 'Behaviour & context' },
  { id: 'buttonsCards', label: 'Buttons & cards', needsAgentUi: true },
  { id: 'productFeeds', label: 'Product feeds' },
  { id: 'knowledge', label: 'Knowledge' },
  { id: 'history', label: 'History' },
  { id: 'storeSection', label: 'Store section' },
];

export const hasAgentUi = (chatBot) => chatBot != null && 'agentUi' in chatBot;

export const visibleSections = (chatBot) => SECTIONS.filter(({ needsAgentUi }) => !needsAgentUi || hasAgentUi(chatBot));

export const resolveSection = (requestedSection, chatBot) => {
  const sections = visibleSections(chatBot);
  return sections.some(({ id }) => id === requestedSection) ? requestedSection : sections[0].id;
};

// Store section was a top-level tab; its old links open the section of the same name instead.
export const legacyTabRedirect = (requestedTab, isSuperAdmin) =>
  requestedTab === 'storeSection' && isSuperAdmin ? { tab: 'personalization', section: 'storeSection' } : null;

// Unknown values (old ?tab=resources links) and super-admin tabs for a merchant land on personalization.
export const resolveTab = (requestedTab, isSuperAdmin) =>
  !TABS.includes(requestedTab) || (!isSuperAdmin && SUPER_ADMIN_TABS.includes(requestedTab))
    ? 'personalization'
    : requestedTab;
